import { render } from "./HomeCN.vue?vue&type=template&id=7abd4e30&scoped=true"
import script from "./HomeCN.vue?vue&type=script&lang=js"
export * from "./HomeCN.vue?vue&type=script&lang=js"

import "./HomeCN.vue?vue&type=style&index=0&id=7abd4e30&lang=less&scoped=true"
import "./HomeCN.vue?vue&type=style&index=1&id=7abd4e30&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abd4e30"]])

export default __exports__